import { useState } from 'react';
import type { InsightRunDetail } from '@/lib/insights.ts';
import { useHashTabs } from '@/lib/useHashTabs.ts';

type RunTab = 'report' | 'chat';

export const RUN_TABS: readonly { key: RunTab; label: string }[] = [
  { key: 'report', label: 'Report' },
  { key: 'chat', label: 'Chat' },
];

/**
 * The run page's tab, kept in the URL hash. Which tab opens without one is
 * decided once, by the run as it was when the page opened: a run finishing
 * while it is watched does not pull the reader out of its chat.
 */
export function useRunTabs(run: InsightRunDetail | undefined, working: boolean) {
  const [openingTab, setOpeningTab] = useState<RunTab | null>(null);
  if (run && openingTab === null) {
    setOpeningTab(run.report && !working ? 'report' : 'chat');
  }

  return useHashTabs(RUN_TABS, openingTab ?? 'chat');
}
